import React, { useState } from 'react';
import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: process.env.REACT_APP_USER_POOL_ID,
  ClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
};

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const userPool = new CognitoUserPool(poolData);
    const cognitoUser = new CognitoUser({ Username: email, Pool: userPool });
    const authDetails = new AuthenticationDetails({ Username: email, Password: password });

    cognitoUser.authenticateUser(authDetails, {
      onSuccess: (result) => {
        setLoading(false);
        onLogin(email, result.getIdToken().getJwtToken());
      },
      onFailure: (err) => {
        setLoading(false);
        setError(err.message || 'Authentication failed');
      },
      newPasswordRequired: () => {
        setLoading(false);
        setError('Password reset required. Please contact admin.');
      },
    });
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <div style={styles.logoIcon}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="10" rx="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>
          <h1 style={styles.title}>Agentic AI Chat</h1>
          <p style={styles.subtitle}>Challenger MCP · AgentCore Gateway · Amazon Bedrock</p>
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoFocus
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button style={{ ...styles.btn, ...(loading ? styles.btnDisabled : {}) }} type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0d0f1a 0%, #161929 100%)',
    padding: '1rem',
  },
  card: {
    background: '#161929',
    border: '1px solid #2a3050',
    borderRadius: '16px',
    padding: '2.5rem 2rem',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 32px 64px rgba(0,0,0,0.5)',
  },
  logoWrap: { textAlign: 'center', marginBottom: '2rem' },
  logoIcon: {
    width: '56px', height: '56px',
    background: '#7c6eff',
    borderRadius: '14px',
    display: 'inline-flex',
    alignItems: 'center', justifyContent: 'center',
    color: '#fff',
    marginBottom: '0.75rem',
  },
  title: {
    fontSize: '1.6rem', fontWeight: '700',
    background: 'linear-gradient(90deg, #7c6eff, #9d93ff)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  subtitle: { color: '#8892a8', fontSize: '0.8rem', marginTop: '0.25rem' },
  error: {
    background: 'rgba(248,113,113,0.1)',
    border: '1px solid rgba(248,113,113,0.3)',
    color: '#f87171',
    padding: '0.7rem 0.9rem',
    borderRadius: '8px',
    fontSize: '0.85rem',
    marginBottom: '1rem',
  },
  field: { marginBottom: '1.25rem' },
  label: { display: 'block', fontSize: '0.8rem', color: '#8892a8', marginBottom: '0.4rem', fontWeight: '500' },
  input: {
    width: '100%', padding: '0.7rem 0.9rem',
    background: '#1e2237', border: '1px solid #2a3050',
    borderRadius: '8px', color: '#e2e8f0',
    fontSize: '0.9rem', outline: 'none',
    transition: 'border-color 0.2s',
  },
  btn: {
    width: '100%', padding: '0.8rem',
    background: '#7c6eff', border: 'none',
    borderRadius: '8px', color: '#fff',
    fontSize: '0.95rem', fontWeight: '600',
    cursor: 'pointer', marginTop: '0.5rem',
    transition: 'background 0.2s',
  },
  btnDisabled: { opacity: 0.6, cursor: 'not-allowed' },
};
